import PropTypes from "prop-types";
import React, { useContext } from "react";
import StaticContent from "../../../context/ContentContext"
import { Link } from "react-router-dom";
import { multilanguage } from "redux-multilanguage";

const MobileNavMenu = ({ strings }) => {
  const menuJson = useContext(StaticContent);

  const items = menuJson?.storeData?.data?.contentManagement?.data?.content?.items;
  const rawMenu = (items && items.length > 0) ? items[0].menu : [];
  const menu = rawMenu ? [...rawMenu] : [];

  const RenderMobileMenuItem = ({ item }) => {
    const hasChildren = item.children && item.children.length > 0;
    return (
      <li className={hasChildren ? "menu-item-has-children" : ""} key={item.id || Math.random()}>
        <Link to={process.env.PUBLIC_URL + item.url}>{item.shortCode}</Link>
        {hasChildren && (
          <ul className="sub-menu">
            {item.children.map((child, index) => (
              <RenderMobileMenuItem item={child} key={index} />
            ))}
          </ul>
        )}
      </li>
    );
  };

  return (
    <nav className="offcanvas-navigation" id="offcanvas-navigation">
      <ul>
        {menu?.map((data, key) => {
          return (
            <li className={data?.menuType === 'submenu' ? "menu-item-has-children" : ''} key={key}>
              <Link to={process.env.PUBLIC_URL + data?.mainUrl}>{data.mainTitle}</Link>
              {data?.menuType === 'submenu' && (
                <ul className="sub-menu">
                  {data?.menus?.[0]?.map((link, idx) => {
                    return (
                      <RenderMobileMenuItem item={link} key={idx} />
                    )
                  })}
                </ul>
              )}
            </li>
          )
        })
        }
      </ul>
    </nav>
  );
};

MobileNavMenu.propTypes = {
  strings: PropTypes.object
};

export default multilanguage(MobileNavMenu);
